import { Col, Row, Form, Input, Breadcrumb, Select, Switch, Tabs, message } from "antd";
import { useMutation, useQuery } from "react-query";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { createUser, editUser } from "../../api/users";
import CancelBtn from "../UI/CancelButton/CancelBtn";
import { CheckPassword } from "../UI/User-Password/Checkpassword";
import { useTranslation } from "react-i18next";
import { getRolesDropdown } from "../../api/roles";
import { Link } from "react-router-dom";
import { getLanguages } from "../../api/languages";
import AddEditModal from "../UI/ModalComponent/AddEditModal/addeditcomponent";
import AddEditButton from "../UI/AddEditButton/addeditbutton";
import { userType } from "./userType";
import { CheckPasswordSimple } from "../UI/User-Password/CheckPasswordSimple";
import { getIsComplexPassword } from "../../utils/main-utils";
interface OptionType {
  id: number;
  value: string;
}

type ErrorsType = {
  fullname?: string | undefined;
  username?: string | undefined;
  email?: string | undefined;
  role?: string | undefined;
};
function AddUsers() {
  const { t } = useTranslation("common");
  const { state } = useLocation();
  const [key, setKey] = useState("1");
  const navigate = useNavigate();
  const [password, setPassword] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [capital, setCapital] = useState(false);
  const [number, setNumber] = useState(false);
  const [special, setSpecial] = useState(false);
  const [space, setSpace] = useState(false);
  const [checkedPassword, setCheckedPassword] = useState(false);
  const [allTrue, setAllTrue] = useState(false);
  const [mustinclude, SetMustInclude] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState('')

  const [errors, setErrors] = useState<ErrorsType>({
    fullname: undefined,
    username: undefined,
    email: undefined,
    role: "set role",
  });

  const onChange = (key: string) => {
    setKey(key);
  };
  const items = [
    {
      key: "1",
      label: `${t("general-information")}`,
    },
  ];

  var strongRegex = new RegExp(`^.{8,}`);
  var strongRegexSimplePassword = new RegExp(`^.{4,}`);
  var stRegex = new RegExp(`^(?=.*[A-Z])`);
  var numRegex = new RegExp(`(?=.*[0-9])`);
  var speRegex = new RegExp(`^(?=.*[!@#$%^&*.+-/])`);
  var spaces = new RegExp(`^(?!.* )`);

  useEffect(() => {
    if (getIsComplexPassword()) {
      setAllTrue(
        password && capital && number && special && space && checkedPassword
      );
    } else {
      setAllTrue(
        password && checkedPassword
      );
    }

  }, [password, capital, number, special, space, checkedPassword]);

  useEffect(() => {
    SetMustInclude(password && capital && number && special && space);
  }, [password, capital, number, special, space]);

  const handlePasswordChange = (e: any) => {
    if (getIsComplexPassword()) {
      setPassword(strongRegex.test(e.target.value));
      setCapital(stRegex.test(e.target.value));
      setNumber(numRegex.test(e.target.value));
      setSpecial(speRegex.test(e.target.value));
      setSpace(spaces.test(e.target.value));
    } else {
      setPassword(strongRegexSimplePassword.test(e.target.value));
    }
    setNewPassword(e.target.value);
  };

  const handleConfirmPasswordInput = (e: any) => {
    setConfirmPassword(e.target.value)
  }

  useEffect(() => {
    setCheckedPassword(newPassword === confirmPassword && newPassword.length > 0)
  }, [newPassword, confirmPassword])

  const { id } = useParams();
  const isEdit = () => {
    return !!id;
  };

  const [user, setUser] = useState<userType | undefined>();
  const [open, setOpen] = useState(false);
  const [formatedRoles, setFormatedRoles] = useState<OptionType[]>();
  const [formatedLangs, setFormatedLangs] = useState<OptionType[]>();
  const { isLoading: loadingRoles } = useQuery("users", getRolesDropdown, {
    refetchOnWindowFocus: false,
    onSuccess: (res) => {
      setFormatedRoles(
        res.data.map((role: any) => {
          return { value: role.id, label: role.name };
        })
      );
    },
  });
  useQuery("langs", getLanguages, {
    refetchOnWindowFocus: false,
    onSuccess: (res) => {
      setFormatedLangs(
        res.data.map((lang: any) => {
          return { value: lang.name, label: lang.name };
        })
      );
    },
  });
  useEffect(() => {
    if (isEdit()) {
      setUser(state);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({
      fullName: user?.fullName,
      userName: user?.userName,
      email: user?.email,
      prefferedLanguage: user?.prefferedLanguage,
      roleId: user?.role?.id,
    });
  }, [user, form]);

  const { mutate: mutateCreateUpdate, isLoading: isSaving } = useMutation(
    !isEdit() ? "createUser" : "edituser",
    !isEdit()
      ? (user: userType) => createUser({ ...user, isComplex: getIsComplexPassword() })
      : (user: userType) => editUser(id, { ...user, isComplex: getIsComplexPassword() }),
    {
      onSuccess: (res) => {
        setOpen(false);
        navigate("/users");
        message.success("Complete successfully");
      },
      onError: (data: any) => {
        message.error(data.response.data.message)
      },
    }
  );

  const handleFinish = () => {
    const newuser = form.getFieldsValue();
    newuser.image = null;
    if (form.getFieldsValue().prefferedMode) {
      newuser.prefferedMode = "Dark";
    } else {
      newuser.prefferedMode = "Light";
    }
    mutateCreateUpdate(newuser);
  };

  const handleFullnameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (/^[a-zA-Z ]+$/.test(e.target.value)) {
      setErrors({
        fullname: undefined,
        username: errors.username,
        email: errors.email,
        role: errors.role,
      });
    } else {
      setErrors({
        fullname: "Full name can only contain letters and spaces",
        username: errors.username,
        email: errors.email,
        role: errors.role,
      });
    }
  };
  const handleUsernameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (/^[a-zA-Z][\w]*$/.test(e.target.value)) {
      setErrors({
        username: undefined,
        email: errors.email,
        fullname: errors.fullname,
        role: errors.role,
      });
    } else {
      setErrors({
        username:
          "Username can only contain letters, numbers, or underscores, and cannot start with a space or symbol",
        email: errors.email,
        fullname: errors.fullname,
        role: errors.role,
      });
    }
  };
  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e.target.value)) {
      setErrors({
        email: undefined,
        username: errors.username,
        fullname: errors.fullname,
        role: errors.role,
      });
    } else {
      setErrors({
        email: "Email is not valid",
        username: errors.username,
        fullname: errors.fullname,
        role: errors.role,
      });
    }
  };
  const handleRoleChange = (e: any) => {
    const isActive = form.getFieldValue("isActive");
    if (e === 1 && !isActive) {
    }

    setErrors({
      email: errors.email,
      username: errors.username,
      fullname: errors.fullname,
      role: undefined,
    });
  };

  return (
    <>
      <Form layout="vertical" form={form} onFinish={handleFinish} id="userform">
        <Row>
          <Col offset={1} style={{ marginBottom: "10px" }}>
            <Breadcrumb
              items={[
                {
                  title: <Link to="/main">{t("home")}</Link>,
                },
                { title: <Link to="/users">{t("users-list")}</Link> },
                {
                  title: (
                    <> {isEdit() ? `${t("edit-user")}` : `${t("add-user")}`}</>
                  ),
                },
                {
                  title: (
                    <span className="breadcrumbcolor">
                      {t("general-information")}
                    </span>
                  ),
                },
              ]}
            />
          </Col>
          {isEdit() ? (
            <Col className="editTitle" span={20} offset={1}>
              {user?.fullName}
            </Col>
          ) : (
            <Col className="editTitle" span={20} offset={1}>
              {t("add-user")}
            </Col>
          )}
        </Row>
        <Row>
          <Col offset={1} span={22}>
            <Tabs
              className="ant-tab"
              defaultActiveKey="1"
              activeKey={key}
              items={items}
              onChange={onChange}
            />
          </Col>
        </Row>
        <Row
          className={!isEdit() ? "main-row-create" : "main-row-edit"}
          style={{ minHeight: "53vh" }}
        >
          <Col offset={1} span={6}>
            <Form.Item
              name="fullName"
              label={t("fullname")}
              rules={[
                {
                  required: true,
                  message: "fullname is required",
                },
              ]}
            >
              <Input
                maxLength={50}
                autoComplete="off"
                data-testid="fullname-input"
                id="fullname"
                placeholder={`${t("enter-text")}`}
                onChange={(e) => {
                  handleFullnameChange(e);
                }}
              />
            </Form.Item>

            <Form.Item
              name="userName"
              label={t("username")}
              rules={[
                {
                  required: true,
                  message: "user name is required",
                },
              ]}
            >
              <Input
                maxLength={20}
                autoComplete="new-username"
                data-testid="username-input"
                placeholder={`${t("enter-text")}`}
                onChange={(e) => handleUsernameChange(e)}
              />
            </Form.Item>

            <Form.Item name="email" label={t("email")}>
              <Input
                maxLength={50}
                autoComplete="off"
                data-testid="email-input"
                placeholder={`${t("enter-email")}`}
                onChange={(e) => handleEmailChange(e)}
              />
            </Form.Item>

            <Form.Item
              name="prefferedLanguage"
              label={t("preffered-language")}
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select
                showSearch={true}
                optionFilterProp="label"
                placeholder={`${t("select-language")}`}
                options={formatedLangs}
              />
            </Form.Item>

            <Form.Item
              name="roleId"
              label={`${t("role")}`}
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select
                showSearch={true}
                optionFilterProp="label"
                placeholder={`${t("select-roles")}`}
                loading={loadingRoles}
                options={formatedRoles}
                onChange={(e) => handleRoleChange(e)}
              />
            </Form.Item>
          </Col>
          {!isEdit() && (
            <Col span={6}>
              <Form.Item
                name="password"
                label={`${t("password")}`}
                rules={[
                  {
                    required: true,
                    message: "password is required",
                  },
                ]}
              >
                <Input.Password
                  maxLength={20}
                  autoComplete="new-password"
                  data-testid="passwordInput"
                  placeholder={`${t("enter-text")}`}
                  onChange={handlePasswordChange}
                />
              </Form.Item>

              <Form.Item
                label={t("confirm-password")}
                rules={[
                  {
                    required: true,
                    message: "confirm password is required",
                  },
                ]}
              >
                <Input.Password
                  maxLength={20}
                  autoComplete="new-password"
                  data-testid="repeatPasswordInput"
                  placeholder={`${t("enter-text")}`}
                  onChange={handleConfirmPasswordInput}
                />
              </Form.Item>
              {getIsComplexPassword() ?
                <CheckPassword
                  password={password}
                  capital={capital}
                  number={number}
                  special={special}
                  space={space}
                  checkedPassword={checkedPassword}
                  allTrue={allTrue}
                  mustinclude={mustinclude}
                /> : <CheckPasswordSimple
                  password={password}
                  checkedPassword={checkedPassword}
                  allTrue={allTrue}
                />
              }
            </Col>
          )}
          <Col offset={isEdit() ? 1 : 0} span={6}>
            {user ? (
              <>
                <Form.Item
                  label={`${t("theme")}`}
                  name="prefferedMode"
                  valuePropName={
                    user?.prefferedMode === "Dark" ? "checked" : ""
                  }
                  initialValue={user?.prefferedMode ? "Dark" : "Light"}
                >
                  {user?.prefferedMode === "Dark" ? (
                    <Switch
                      defaultChecked
                      checkedChildren={t("dark")}
                      unCheckedChildren={t("light")}
                    />
                  ) : (
                    <Switch
                      checkedChildren={t("dark")}
                      unCheckedChildren={t("light")}
                    />
                  )}
                </Form.Item>

                <Form.Item
                  label={`${t("status")}`}
                  name="isActive"
                  valuePropName={user?.isActive ? "checked" : ""}
                  initialValue={user?.isActive ? true : false}
                >
                  {user?.isActive ? (
                    <Switch
                      defaultChecked
                      checkedChildren={t("active")}
                      unCheckedChildren={t("inactive")}
                    />
                  ) : (
                    <Switch
                      checkedChildren={t("active")}
                      unCheckedChildren={t("inactive")}
                    />
                  )}
                </Form.Item>
              </>
            ) : (
              <>
                <Form.Item
                  name="prefferedMode"
                  initialValue="Light"
                  label={`${t("theme")}`}
                >
                  <Switch
                    checkedChildren={t("dark")}
                    unCheckedChildren={t("light")}
                  />
                </Form.Item>
                <Form.Item
                  label={`${t("status")}`}
                  name="isActive"
                  valuePropName="checked"
                  initialValue={true}
                >
                  <Switch
                    disabled
                    defaultChecked
                    checkedChildren={t("active")}
                    unCheckedChildren={t("inactive")}
                  />
                </Form.Item>
              </>
            )}
          </Col>
        </Row>
      </Form>
      <Row>
        <Col offset={1} span={4}>
          <CancelBtn />
        </Col>
        <Col
          offset={16}
          span={2}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "20px",
          }}
        >
          {isEdit() ? (
            <Col>
              <AddEditButton
                data-testid="add-button"
                disabled={!!errors.fullname || !!errors.username}
                onClick={() => {
                  setOpen(true);
                }}
                isLoading={isSaving}
              />
            </Col>
          ) : (
            <Col>
              <AddEditButton
                data-testid="add-button"
                disabled={
                  !!errors.fullname ||
                  !!errors.username ||
                  !!errors.role ||
                  !checkedPassword || !allTrue
                }
                onClick={() => {
                  setOpen(true);
                }}
                isLoading={""}
              />
            </Col>
          )}
        </Col>
      </Row>
      <AddEditModal
        form="userform"
        open={open}
        setOpen={setOpen}
        name={<span>{user?.fullName}</span>}
        title={`${t("modal-user")}`}
        isSaving={isSaving}
      />
    </>
  );
}
export default AddUsers;
